@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600;700&display=swap");
@import "./styles/tokens.css";

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#root {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-text);
  font-size: var(--fs-body-small);
  line-height: var(--lh-body-small);
  color: var(--text-body);
  background: var(--surface-white);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  color: var(--text-primary);
  font-family: var(--font-display);
  font-weight: 500;
  letter-spacing: -0.01em;
}

p {
  margin: 0;
}

a {
  color: var(--blue-600);
  text-decoration: none;
  transition: color var(--dur-base) var(--ease-smooth);
}

a:hover {
  color: var(--blue-500);
}

button {
  font-family: var(--font-sans);
  cursor: pointer;
  border: none;
  background: none;
}

img,
svg {
  display: block;
  max-width: 100%;
}

::selection {
  background: var(--blue-500);
  color: #fff;
}

.container {
  width: 100%;
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 0 var(--container-pad);
}

.section {
  padding: var(--s-120) 0;
}

.section--dark {
  background: var(--surface-dark);
  color: var(--text-on-dark);
}

.section--dark h1,
.section--dark h2,
.section--dark h3 {
  color: var(--text-on-dark);
}

@media (max-width: 896px) {
  .section {
    padding: var(--s-80) 0;
  }
}
